import { render, staticRenderFns } from "./PreviewRoom.vue?vue&type=template&id=580b74fe&v-if=roomId&"
import script from "./PreviewRoom.vue?vue&type=script&lang=js&"
export * from "./PreviewRoom.vue?vue&type=script&lang=js&"
import style0 from "./PreviewRoom.vue?vue&type=style&index=0&id=580b74fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports